// paste firebase config here
export const firebaseApp = {
  apiKey: "AIzaSyBfZnjyw2VmcLyUO5hJYOWLuZ-0F6wtzJ0",
  authDomain: "pwa-poker.firebaseapp.com",
  projectId: "pwa-poker",
  storageBucket: "pwa-poker.appspot.com",
  messagingSenderId: "1063537936607",
  appId: "1:1063537936607:web:dc9e1b17ad681412b0c16a"
  };